<template>
  <div class="" style="padding-bottom: 0.5rem">

    <div style="width: 100%;position: relative;">
      <el-carousel height="500px" style="margin-top: 0rem; background: #fff">
        <el-carousel-item v-for="(item, index) of list" :key="index">

          <img
            v-if="item.VIndexLine !=null && item.VIndexLine !=''"
            :src="item.url+item.vattachmentRemotePath"
            alt=""
            style="width: 100%; height: 100%;cursor: pointer"
            @click="openImage(item.url+item.VIndexLine)"
           />
          <img
            v-else
            :src="item.url+item.vattachmentRemotePath"
            alt=""
            style="width: 100%; height: 100%;"
          />
        </el-carousel-item>


      </el-carousel>

      <div class="search" style="margin-top: 10px">


        <!-- 下拉搜索 -->
        <el-select class="selectSty" v-model="valueKey" @mouseenter.native="showSelect" default-first-option ref="selectSearch">
          <el-option  v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"  ></el-option>
        </el-select>
        <!-- 竖线分隔符 -->
        <div class="line"></div>
        <!-- 关键词输入框 -->
        <el-autocomplete v-model="input" style="width: 100%;"  :fetch-suggestions="querySearch"  @select="handleSelect"placeholder="请输入检索内容" prefix-icon="el-icon-search">
        </el-autocomplete>
        <!-- 竖线分隔符 -->
        <div class="line line2"></div>
        <div class="searchBtn" >
          <span @click="searchBtn()" >搜索</span></div>
      </div>
    </div>
      <!-- 中间内容 -->
      <div class="inner paixin-home__center" am-width="md" style="height: auto; margin-top: 0.25rem;padding-bottom: 0.5rem;width: 1600px">
        <div class="hot-topic-box" >

          <a class="hot-topic-item" v-for="(item, index) of systemList" href="javascript:void(0)" @click="toZhuanti(item)" >
            <img :src="item.imgUrl" class="img-inner"  data-v-76ef6247="">
          </a>
        </div>


        <div style="margin-top: 28px">
          <div class="inspiration" data-v-49099636="">
            <div class="inspiration__content" data-v-49099636="">
              <div id="inspiration__content-item" class="inspiration__content-item" data-v-49099636="">
                <!--            <div class="inspiration__content-item-top" data-v-49099636=""></div>-->
                <div class="inspiration__content-item-list" data-v-49099636="">

                  <a class="s-c inspiration__stairscoat"  v-for="(item, index) of fenleiList"  href="javascript:void(0)" @click="toPictureShare(item.id)" data-v-25f634ee=""
                     data-v-49099636="">
<!--                    <div class="s-c__b2" data-v-25f634ee=""></div>-->
                    <div class="s-c__ct" data-v-25f634ee="">
                      <img class="s-c__img lazyload s-c__i--s lazy"  data-v-25f634ee=""
                           :src="item.imgUrl">
                      <div class="s-c__if" data-v-25f634ee="">
                        <div class="default-cover" data-v-2ee9cf5e="" data-v-49099636="" data-v-25f634ee-s="">
                          <div class="default-cover__top" data-v-2ee9cf5e=""><!----></div>
                          <div class="default-cover__bottom" data-v-2ee9cf5e=""><h4 class="default-cover__title-text"
                                                                                    data-v-2ee9cf5e="">{{item.title}}</h4></div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>



<!--        <div class="banner" style="border:1px solid #eee;height: 120px;font-weight: 700;text-align: center;font-size: large;position: relative;margin-top: 10px;">
                   关于我们

        </div>-->

      </div>


  </div>
</template>


<script>
// import PicShareIndex from './components/index/picShareIndex'
// import PicShareOne from './components/index/picShareOne'
// import PicShareTwo from './components/index/picShareTwo'
import { jump,getUser } from '@/untils/auth'
export default {
    components: {
      // PicShareOne,
      // PicShareTwo
      // PicShareIndex
    },
    data (){
        return {
          // value: 'VAttachmentName',
          valueKey: '',
          input: '',
          list: [],

          systemList: [],

          fenleiList: [],
          statusList: [
            {
              value: 'keyrord',
              label: '关键词'
            },
            {
              value: 'VAttachmentName',
              label: '图名'
            },
            {
              value: 'author',
              label: '摄影师'
            },
          ],

        }
    },
    created (){

      // this.valueKey = this.statusList[0].value;

      this.hotRes();
      /*轮播图*/
      this.axios.post(window.IPConfig.IP + "/tbConfigLunbo/queryAll.do",{VStatus:0}).then((res) => {
        if (res.status == 200) {
          console.log(res)
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              res.data.obj.forEach((item) => {
                this.list.push({title:item.VName, vattachmentRemotePath:item.VLine,VIndexLine:item.VIndexLine,url:res.data.url});
              });
            }
          }
        }
      });
      /*分类*/
      this.axios.post(window.IPConfig.IP + "/tBCategory/getIndexFenlei.do").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              res.data.obj.forEach((item) => {
                  this.fenleiList.push({id:item.VCateId,title:item.VCateTitle, imgUrl:res.data.url+item.VLinkUrl});
              });
            }
          }
        }
      });

      /*专题*/
      this.axios.post(window.IPConfig.IP + "/tbConfigZhuanti/queryAll.do").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              res.data.obj.forEach((item) => {
                this.systemList.push({VConfigId:item.VConfigId,imgUrl:res.data.url+item.VLine});
              });
            }
          }
        }
      });
    },


    mounted() {
      document.getElementsByClassName("fullDiv")[0].style.display="none";
    },


    methods: {
      jump,
      tiao(url) {
          window.open(url);
      },



      toPictureShare(id){
          let routeData = this.$router.resolve({
            path: 'pictureShare', query: {
              categoryid: id,
            }
          })

          window.open(routeData.href, '_blank')

      },

      openImage(url){
          let routeData = this.$router.resolve({
            path: 'indexIntro', query: {
              pathUrl: url,
            }
          })

          window.open(routeData.href, '_blank')
      },


      showSelect(){
        if(this.valueKey.length!=0){
          this.$refs.selectSearch.toggleMenu()
        }
      },
      searchBtn(){
          if (!this.input) {
            this.$message({
              message: '请输入搜索内容',
              type: 'error',
              center: true
            });
          } else {
            if (this.valueKey == null || this.valueKey == '') {
              this.valueKey = 'serarchVal'
            }

            this.$router.push({
              path: 'pictureShare',
              query: {
                serarchVal: this.input,
                searchKey: this.valueKey
              }
            })
          }
      },


      toZhuanti(item){
          let routeData = this.$router.resolve({
            path: 'zhuantipictureList', query: {
              VConfigId: item.VConfigId,
            }
          })
          window.open(routeData.href, '_blank')
      },

      querySearch(queryString, cb) {
          console.log(this.labelList)
          let programList = [];
          if (this.labelList != undefined) {
            for (let i = 0; i < this.labelList.length; i++) {
              programList.push({'value': this.labelList[i]})
            }
          }
          let results = queryString ? programList.filter(this.createFilter(queryString)) : programList;
          //基本思路就是实现一个过滤器，过滤存在你输入字段的所有数据。
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 1000 * Math.random());
      },

      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.indexOf(queryString) > -1);
        };
      },

      // 热门搜索关键字
      hotRes (){
        if (getUser()) {
          var createdBy = JSON.parse(getUser()).principal.VUserId;
          var data = {key: "ess_picture_hotSearch_"+createdBy}
          this.axios.post(window.IPConfig.IP + "/tBHotSearch/queryKeyHotSearCher.do", data).then((res) => {
            if (res.data.status == 200) {
              this.labelList = res.data.obj
            }
          });
        }

      },

      handleSelect(item) {
          let routeData = this.$router.resolve({path:'pictureShare',query:{
              serarchVal: item.value
            }})
          window.open(routeData.href,'_blank')
      },


    }
}
</script>

<style>


    .education-el-main {
        padding: 0;
        margin: 0.2rem 0rem;
    }
    .AdBox .dialog_close {
        width: 0.7rem;
        padding: 0.05rem 0;
        position: absolute;
        top: 0.55rem;
        right: 0.25rem;
        font-size: 0.2rem;
        cursor: pointer;
        z-index: 3;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.3);
    }


    .search {
      position: absolute;
      left: 50%;
      transform: translate3d(-50%,0,0);
      margin-top: 10px;
      width: 40%;
      display: inline-flex;
      -ms-flex-align: center;
      align-items: center;
      /*border: 0.02rem solid rgba(88, 108, 234, 1);*/
      box-shadow: 0 0 30px 0 rgba(0,0,0,.12);
      border-radius: 6px;
      display: flex;
      background: #fff;
      box-shadow: 0 0 30px 0 rgba(0,0,0,.12);
      z-index: 999999;
      top:75%;
    }

    .search .el-select .el-input__inner{
      border:none;
    }

    .el-autocomplete .el-input__inner{
      border:none;
    }

    .search .line {
      width: 0.01rem;
      height: 0.2rem;
      background: #dcdfe6;
    }
    .search .textInput {
      width: 4.8rem;
      height: 0.54rem;
    }
    .search .searchBtn {
      width: 1.2rem;
      height: 0.54rem;
      cursor: pointer;
      display: flex;
      background: #fff;
      color: #fff;
      line-height: 54px;
      justify-content: center;
      align-items: center;
      margin: 0 -26px 0 10px;
      color: #333;
      border-radius: inherit;
    }


    .search .line {
      height: 0.4rem;
    }

    .search .line2 {
      height: 0.2rem;
    }


    .hot-topic-box {
      width: 100%;
      display: grid;
      grid-row-gap: 20px;
      grid-column-gap: 20px;
      grid-template-columns: repeat(3,476px);
      grid-template-rows: repeat(2,260px)
    }


    .hot-topic-item {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      overflow: hidden
    }

     .hot-topic-item .img-inner {
      transition: transform .2s ease-in;
      width: 100%;
      height: 100%;
      /*-o-object-fit: cover;*/
      /*object-fit: cover*/
    }

    .hot-topic-item .img-inner[data-v-76ef6247]:hover {
      transform: scale(1.05)
    }


    .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 280px 0px;
      grid-column-gap: 20px;
      -moz-column-gap: 20px;
      column-gap: 20px;
      /*grid-row-gap: 24px;*/
      /*row-gap: 24px;*/
      /*margin-bottom: 40px*/
    }



    .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636]::last-child {
      margin-bottom: 0
    }

    .inspiration .inspiration__content .inspiration__content-item-list .inspiration__stairscoat[data-v-49099636] {
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none
    }





    .default-cover .default-cover__top .default-cover__hot-icon[data-v-2ee9cf5e] {
      width: 15%;
      max-width: 62px
    }

    .default-cover .default-cover__bottom[data-v-2ee9cf5e] {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0 0 20px 20px;
      height: 90px;
      background: linear-gradient(180deg,transparent,rgba(0,0,0,.6));
      color: #fff
    }

    .default-cover .default-cover__bottom .default-cover__title-text[data-v-2ee9cf5e] {
      font-size: 16px;
      font-weight: 600
    }

    .default-cover .default-cover__bottom .default-cover__img-num[data-v-2ee9cf5e] {
      opacity: .8;
      margin-top: 2%;
      font-size: 14px
    }


    .hot-topic-box {
      width: 100%;
      display: grid;
      grid-row-gap: 20px;
      grid-column-gap: 20px;
      grid-template-columns: repeat(3,476px);
      grid-template-rows: repeat(2,260px)
    }


    @media screen and (max-width: 1681px) {
      .hot-topic-box {
        grid-template-columns:repeat(3,385px);
        grid-template-rows: repeat(2,243px)
      }
    }

    @media screen and (min-width: 1920px) {
      .hot-topic-box {
        grid-template-columns:repeat(3,520px);
        grid-template-rows: repeat(2,300px)
      }
    }

    [am-theme~=warm] .content {
      background-color: #9acd32;
      color: red
    }

    @media only screen and (max-width: 768px) {
      [am-hidden~=xs] {
        display:none!important
      }
    }

    @media only screen and (max-width: 1200px) {
      [am-hidden~=md] {
        display:none!important
      }
    }

    @media screen and (min-width: 1681px)and (max-width:1919px) {
      [am-width~=md] {
        width:1468px!important
      }
    }

    @media screen and (min-width: 1920px) {
      [am-hidden~=lg] {
        display:none!important
      }
    }

    @media screen and (max-width: 1680px) {
      [am-width~=md] {
        width:1200px!important;
      }
    }

    .paixin-home__center[data-v-d4d5db06] {
      /* width:1600px; */
      margin: 0 auto;
      position: relative;
      z-index: 1;
      background-color: #fff
    }



    .s-c[data-v-25f634ee] {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center
    }

    .s-c:hover .s-c__i--s[data-v-25f634ee] {
      transform: scale(1.1)
    }

    .s-c .s-c__b1[data-v-25f634ee] {
      height: 3%;
      width: 90%;
      background-color: #eee
    }

    .s-c .s-c__b2[data-v-25f634ee] {
      height: 5%;
      width: 95%;
      background-color: #f5f5f5;
      border-radius: 4px
    }

    .s-c .s-c__ct[data-v-25f634ee] {
      position: absolute;
      height: 100%;
      width: 100%;
      border-radius: 4px;
      overflow: hidden
    }

    .s-c .s-c__ct .lazyload[data-v-25f634ee] {
      opacity: 0
    }

    .s-c .s-c__ct .s-c__img[data-v-25f634ee] {
      height: 100%;
      width: 100%;
      /*-o-object-fit: cover;*/
      /*object-fit: cover;*/
      transition: all .3s ease
    }

    .s-c .s-c__ct .s-c__img.lazy[data-v-25f634ee] {
      opacity: 1
    }

    .s-c .s-c__ct .s-c__if[data-v-25f634ee] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%
    }

    .default-cover .default-cover__top .default-cover__hot-icon[data-v-2ee9cf5e] {
      width: 15%;
      max-width: 62px
    }

    .default-cover .default-cover__bottom[data-v-2ee9cf5e] {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0 0 20px 20px;
      height: 90px;
      background: linear-gradient(180deg,transparent,rgba(0,0,0,.6));
      color: #fff
    }

    .default-cover .default-cover__bottom .default-cover__title-text[data-v-2ee9cf5e] {
      font-size: 16px;
      font-weight: 600
    }

    .default-cover .default-cover__bottom .default-cover__img-num[data-v-2ee9cf5e] {
      opacity: .8;
      margin-top: 2%;
      font-size: 14px
    }

    .inspiration[data-v-49099636] {
      display: flex;
      height: 100%;
    }

    .inspiration .inspiration__side[data-v-49099636] {
      position: -webkit-sticky;
      position: sticky;
      top: 100px;
      display: flex;
      flex-direction: column;
      height: -webkit-fit-content;
      height: -moz-fit-content;
      height: fit-content;
      min-width: 128px;
      max-width: 128px;
      margin-right: 60px
    }

    @media screen and (max-width: 1600px) {
      .inspiration .inspiration__side[data-v-49099636] {
        margin-right:36px
      }
    }

    .inspiration .inspiration__side .inspiration__side-item[data-v-49099636] {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      width: 100%;
      height: 42px;
      border-radius: 21px;
      background-color: #f5f5f7;
      transition: all .3s ease;
      margin-bottom: 16px
    }

    .inspiration .inspiration__side .inspiration__side-item[data-v-49099636]:hover {
      background-color: #e9e9eb
    }

    .inspiration .inspiration__side .inspiration__side-item:hover.inspiration__side-item--active[data-v-49099636] {
      background-color: #f71558
    }

    .inspiration .inspiration__side .inspiration__side-item.inspiration__side-item--active[data-v-49099636] {
      background-color: #f71558;
      color: #fff;
      font-weight: 600
    }

    .inspiration .inspiration__content[data-v-49099636] {
      flex: 1 1
    }
/*
    .inspiration .inspiration__content .inspiration__content-item-top[data-v-49099636] {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px
    }

    .inspiration .inspiration__content .inspiration__content-item-top .inspiration__content-item-title[data-v-49099636] {
      display: flex;
      align-items: center
    }*/

    .inspiration .inspiration__content .inspiration__content-item-title h3[data-v-49099636] {
      font-size: 22px;
      font-weight: 500;
      color: #000;
      line-height: 30px
    }



    .inspiration .inspiration__content .inspiration__change-btn img[data-v-49099636] {
      width: 16px;
      margin-right: 6px
    }

    .inspiration .inspiration__content .inspiration__change-btn span[data-v-49099636] {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      line-height: 20px
    }



    @media screen and (min-width: 1681px) {
      .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
        grid-template-rows:206px 0px
      }
    }

    @media screen and (max-width: 1680px) {
      .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636] {
        grid-template-rows:170px 0px;
        /*grid-column-gap: 16px;*/
        /*-moz-column-gap: 16px;*/
        /*column-gap: 16px;*/
        /*grid-row-gap: 18px;*/
        /*row-gap: 18px*/
      }
    }

    .inspiration .inspiration__content .inspiration__content-item-list[data-v-49099636]::last-child {
      margin-bottom: 0
    }

    .inspiration .inspiration__content .inspiration__content-item-list .inspiration__stairscoat[data-v-49099636] {
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none
    }

    a[data-v-38268b2c] {
      white-space: nowrap
    }

    .pop[data-v-38268b2c] {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 12%
    }

    .pop a[data-v-38268b2c] {
      width: 34%;
      color: #333;
      font-size: 14px;
      cursor: pointer;
      text-align: left;
      display: inline-block;
      padding: 6px 0
    }

    .pop a[data-v-38268b2c]:hover {
      color: #ff004b
    }

    .default-cover[data-v-2ee9cf5e] {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%
    }

    .default-cover .default-cover__top .default-cover__hot-icon[data-v-2ee9cf5e] {
      width: 15%;
      max-width: 62px
    }

    .default-cover .default-cover__bottom[data-v-2ee9cf5e] {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0 0 20px 20px;
      height: 90px;
      background: linear-gradient(180deg,transparent,rgba(0,0,0,.6));
      color: #fff
    }

    .default-cover .default-cover__bottom .default-cover__title-text[data-v-2ee9cf5e] {
      font-size: 16px;
      font-weight: 600
    }

    .default-cover .default-cover__bottom .default-cover__img-num[data-v-2ee9cf5e] {
      opacity: .8;
      margin-top: 2%;
      font-size: 14px
    }


    .s-c__ct img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      overflow: hidden;
    }
    .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
      padding-left: 15px !important;
    }


    .product-style .el-select-dropdown__item {
      width: calc(100% - 10px);
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }



</style>



// WEBPACK FOOTER //
// src/components/Education/index.vue